import { ComponentType, lazy, Suspense } from "react";

import { Brand } from "../../../store/slices/environmentSlice";
import { useTypedSelector } from "../../../store/store";
import LoadingContainer from "../../containers/LoadingContainer";

const DefaultAgencyRegistration = lazy(() => import("./default"));
const VIDAgencyRegistration = lazy(() => import("./vid"));
const DTWAgencyRegistration = lazy(() => import("./dtw"));
const CENAgencyRegistration = lazy(() => import("./cen"));

const PAGES_BY_BRAND: Record<Brand, ComponentType> = {
  default: DefaultAgencyRegistration,
  vid: VIDAgencyRegistration,
  dtw: DTWAgencyRegistration,
  aov: DefaultAgencyRegistration,
  cen: CENAgencyRegistration,
};

function RootAgencyRegistration() {
  const { brand } = useTypedSelector((state) => state.environment);

  const PageByBrand = PAGES_BY_BRAND[brand] ?? DefaultAgencyRegistration;

  return (
    <Suspense
      fallback={
        <LoadingContainer isLoading>
          <></>
        </LoadingContainer>
      }>
      <PageByBrand />
    </Suspense>
  );
}

export default RootAgencyRegistration;
